import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library as fontAwesomeLibrary} from "@fortawesome/fontawesome-svg-core";
import {faYoutube, faFacebook, faXTwitter, faInstagram} from "@fortawesome/free-brands-svg-icons";
import React, { useState, useEffect } from 'react';
import {Accordion} from "../components/accordion.js";
import {TopicsTable} from "../components/topicstable.js";
import nasaLogo from "../images/nasa-logo.png";

export function Footer() {
    const [useAccordion, setIsAccordion] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            setIsAccordion(window.innerWidth < 1000);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const regionsMap1 = [
      {text: 'Solar Environment Data', link:'/region/sun', span:true},
      {text: 'Earth Magnetosphere Data', link: '/region/earth-magnetosphere', span:true},
      {text: 'Earth Atmosphere Data', link: '/region/earth-atmosphere', span: true}  ,
      {text: 'Interplanetary Space Data', link: '/region/interplanetary-space', span:true},
      {text: 'Planetary Magnetospheres Data', link: '/region/planetary-magnetospheres', span: true},
    ];

    const aboutHelioMap = [
      {text:'Learn about Heliophysics', link:'/learn-about-helio'},
      {text:'Where the Data Comes From', link:'/where-it-comes-from'},
      {text:'Step-by-Step User Guide', link:'/downloading-and-acquiring'},
    ];
    const aboutUsMap =  [
      {text: 'Heliophysics Digital Resource Library (HDRL)', link: '/about'},
      {text: 'Why Open Science?', link:'https://science.nasa.gov/researchers/open-science/'},
      {text: 'Contact Us', email:'heliodata-support-owner@lists.nasa.gov', link:null}
    ];

    let accordionItems = [];

    accordionItems.push({ title: 'Data by Region', contents: [...regionsMap1]});

    accordionItems.push(...[
        { title: 'About Heliophysics Data', contents: aboutHelioMap},
        { title: 'About Us', contents:  aboutUsMap },
    ]);

    fontAwesomeLibrary.add(faYoutube);
    fontAwesomeLibrary.add(faFacebook);
    fontAwesomeLibrary.add(faXTwitter);
    fontAwesomeLibrary.add(faInstagram);

    return (
        <div className="footerOverall">
          {!useAccordion && (<>
          <div className="footerContainer">
              <div className="footerFirstColumnFixedWidth">
                <div className="footerFirstColumnContainer">
                    <div className="footerFirstContainerTitle">
       		    <img src={nasaLogo} alt="Logo" className="footerLogo"/><br />
		    <b>National Aeronautics and Space Administration</b>
                  </div>
                  <div className="footerFirstContainerBody">
                    Open-access gateway to thousands of datasets from NASA Heliophysics missions
                  </div>

                  <div className="footerSocialAlignLeft">
                    <div className="footerSocials">
                      <button className="footerSocialButton" aria-label="FacebookBtn">
                        <a href="https://www.facebook.com/NASA/" target="_Blank" rel="noreferrer">
                          <FontAwesomeIcon icon={faFacebook} />
                        </a>
                      </button>
                      <button className="footerSocialButton" aria-label="XBtn">
                        <a href="https://x.com/NASA?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" target="_Blank" rel="noreferrer">
                          <FontAwesomeIcon icon={faXTwitter} />
                        </a>
                      </button>
                      <button className="footerSocialButton" aria-label="YoutubeBtn">
                        <a href="https://www.youtube.com/nasa" target="_Blank" rel="noreferrer">
                          <FontAwesomeIcon icon={faYoutube} />
                        </a>
                      </button>
                      <button className="footerSocialButton" aria-label="InstagramBtn">
                        <a href="https://www.instagram.com/nasa/" target="_Blank" rel="noreferrer">
                          <FontAwesomeIcon icon={faInstagram} />
                        </a>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="footerSecondColumnContainer">
                <TopicsTable items={accordionItems}/>
              </div>
          </div>
          </>)}

          <div>
            {useAccordion && <Accordion items={accordionItems} className="footerAccordion" />}
          </div>

          <div className="footerNasaInfo">

          <div className="footerBottom">
            <div className="footerBottomLeft">
              <div className="footerNasaInfoItem">
                <a href="/sitemap" target="_Blank" rel="noreferrer">
                  Sitemap
                </a>
              </div>
              <div className="footerNasaInfoItem">
                <a href="https://www.nasa.gov/about/highlights/HP_Privacy.html" target="_Blank" rel="noreferrer">
                  Privacy Policy
                </a>
              </div>

              <div className="footerNasaInfoItem">
                <a href="https://www.nasa.gov/audience/formedia/features/communication_policy.html" target="_Blank" rel="noreferrer">
                  Communications Policy
                </a>
              </div>
              <div className="footerNasaInfoItem">
                <a href="https://www.nasa.gov/FOIA/index.html" target="_Blank" rel="noreferrer">
                  Data and Information Policy
                </a>
              </div>
              <div className="footerNasaInfoItem">
                <a href="https://www.nasa.gov/accessibility/" target="_Blank" rel="noreferrer">
                  Accessibility
                </a>
              </div>

              <div className="footerNasaInfoItem">
                <a href="https://www.usa.gov/" target="_Blank" rel="noreferrer">
                  USA.gov
                </a>
              </div>

              <div className="footerNasaInfoItem">
                <a href="/terms-of-service">
                  Terms of Service
                </a>
              </div>
            </div>
            <div className="footerBottomRight">
              <div className="footerNasaInfoItem">
                <a href="mailto:brian.a.thomas@nasa.gov">NASA Official:    <strong>Brian A. Thomas</strong></a>
              </div>
              <div className="footerNasaInfoItem">
                <a href="mailto:olawale.s.jaiyeola@nasa.gov">Webmaster:    <strong>Olawale Jaiyeola</strong></a>
              </div>
            </div>
          </div>
        </div>
        </div>
    );
}
